import { ListItemButton, ListItemIcon, ListItemText, type ButtonProps, type SvgIconProps } from "@mui/material";
import { useLogin, useNotify } from "ra-core";

import type { ValuesOf } from "../models/enums";
import {
    AppleIcon,
    AzureIcon,
    BitbucketIcon,
    DiscordIcon,
    FacebookIcon,
    GithubIcon,
    GitlabIcon,
    GoogleIcon,
    KeycloakIcon,
    LinkedinIcon,
    NotionIcon,
    SlackIcon,
    SpotifyIcon,
    TwitchIcon,
    TwitterIcon,
    WorkosIcon,
} from "./icons";

const providers = [
    "apple",
    "azure",
    "bitbucket",
    "discord",
    "facebook",
    "github",
    "gitlab",
    "google",
    "keycloak",
    "linkedin",
    "notion",
    "slack",
    "spotify",
    "twitch",
    "twitter",
    "workos"
] as const;

export type SocialProvider = ValuesOf<typeof providers>;

const icons: Record<SocialProvider, (props: SvgIconProps) => JSX.Element> = {
    "apple": AppleIcon,
    "azure": AzureIcon,
    "bitbucket": BitbucketIcon,
    "discord": DiscordIcon,
    "facebook": FacebookIcon,
    "github": GithubIcon,
    "gitlab": GitlabIcon,
    "google": GoogleIcon,
    "keycloak": KeycloakIcon,
    "linkedin": LinkedinIcon,
    "notion": NotionIcon,
    "slack": SlackIcon,
    "spotify": SpotifyIcon,
    "twitch": TwitchIcon,
    "twitter": TwitterIcon,
    "workos": WorkosIcon,
}

export const SocialAuthButton = ({
    provider,
    redirect: redirectTo,
}: SocialAuthButtonProps) => {
    const login = useLogin();
    const notify = useNotify();

    const handleClick = () => {
        login({ provider }, redirectTo ?? window.location.toString()).catch(
            error => {
                // The authProvide always reject for OAuth login but there will be no error
                // if the call actually succeeds. This is to avoid react-admin redirecting
                // immediately to the provided redirect prop before users are redirected to
                // the OAuth provider.
                if (error) {
                    notify((error as Error).message, { type: "error" });
                }
            }
        );
    };
    const Icon = icons[provider];
    return (
        <ListItemButton
            onClick={handleClick}
        >
          <ListItemIcon             
            sx={{ minWidth: 40 }}>
            <Icon />
          </ListItemIcon>
          <ListItemText sx={{ textTransform: "capitalize" }} primary="Login" />
        </ListItemButton>

    );
};

export type SocialAuthButtonProps = {
    provider: SocialProvider;
    redirect?: string;
} & ButtonProps;